import "./style.css";
import { getFullDateString, getFullHourAndMinute } from "../../services/formatters";
import { useSession } from "../../hooks/useSession";

export const Riepilogo = ({ showTitle = true }) => {
    const { read } = useSession();

    return (
        <>
            {showTitle && (
                <>
                    <h3 className="text-center">
                        Riepilogo del tuo appuntamento <br />
                    </h3>
                    <br />
                </>
            )}
            <div id="sticky-summary" className="text-center text-md">
                <p className="bold">
                    {read("filialeScelta").nomeFiliale || read("filialeScelta").RagioneSociale} <br />
                </p>
                <p>
                    {read("filialeScelta").citta} - {read("filialeScelta").cap} <br />
                </p>
                <p>{read("filialeScelta").indirizzo || read("filialeScelta").IndirizzoUfficio}</p>
                {read("dataScelta") && read("orarioScelto") && (
                    <p className="bold">
                        {getFullDateString(read("dataScelta").data)} - {read("orarioSceltoLabel")}
                    </p>
                )}
            </div>
        </>
    );
};
